import { Icon, MessageBar, MessageBarType } from '@fluentui/react';
import { useInjectedService } from '../../services/ioc/service-dependency';

import './home.css';
import { useParams } from 'react-router-dom';
import { getUserLang, isNullOrEmpty } from '../../lib/helper';
import { useEffect, useState } from 'react';

const Home = () => {
    const { localizationService } = useInjectedService();

    const currentDate = new Date();
    const startDate = new Date(2023, 2, 22, 13, 50);
    const endDate = new Date(2023, 2, 22, 15, 15);
    let showNotification = startDate.getTime() < currentDate.getTime() && endDate.getTime() > currentDate.getTime();

    // show the notification when url param debug=1
    if (new URL(window.location.href).searchParams.get("debug") === "1") {
        showNotification = true;
    }

    let { culture } = useParams();

    if (
        isNullOrEmpty(culture) ||
        culture === undefined
    ) {
        culture = getUserLang();
    }

    let prepareUrl = "/";
    if (!isNullOrEmpty(culture) && culture !== undefined && localizationService.isValidCulture(culture)) {
        prepareUrl = "/" + culture;
    }

    const [isDesktopSize, setIsDesktopSize] = useState<boolean>(window.innerWidth > 800);

    useEffect(() => {
        window.addEventListener("resize", () => setIsDesktopSize(window.innerWidth > 800));
        return () => {
            window.removeEventListener("resize", () => setIsDesktopSize(window.innerWidth > 800));
        };
    }, [])

    return <div>
        {showNotification &&
            <div className="row">
                <div onClick={() => { window.location.href = 'https://bbraun.events/FiscalYear2022'; }} className='notification'>
                    <div className='notification-text'>
                        <h4>{localizationService.getLocalizedText("Notification")}</h4>
                        <p>{localizationService.getLocalizedText("NotificationDesc")}</p>
                    </div>
                    <div className='notification-button'>
                        <Icon iconName='Play' />
                    </div>
                </div>
            </div>
        }
        <div className="row">
            <div className="col-sm">
                <div className="bbraun-hero">
                    <div className="bbraun-hero-subtitle">
                        {localizationService.getLocalizedText("WelcomeHome")}
                    </div>
                    <div className="bbraun-hero-headline">
                        {localizationService.getLocalizedText("TheBKCApp")}
                    </div>
                    <div className="bbraun-hero-content" dangerouslySetInnerHTML={{ __html: localizationService.getLocalizedText("WelcomeText") }} />
                    <MessageBar messageBarType={MessageBarType.info} className='bbraun-bkc-info-message'>
                        {localizationService.getLocalizedText("BKCInfoMessage")}
                    </MessageBar>
                </div>
            </div>
        </div>
        {isDesktopSize &&
            <div className="row bbraun-sand-bg">
                <div className="col-sm">
                    <div className="bbraun-hero bbraun-hero-mutliple-rows bbraun-hero-mutliple-home-rows mb-0">
                        <div>
                            <div className="bbraun-hero-headline" dangerouslySetInnerHTML={{ __html: localizationService.getLocalizedText("AndroidPhone") }} />
                        </div>
                        <div>
                            <div className="bbraun-hero-headline" dangerouslySetInnerHTML={{ __html: localizationService.getLocalizedText("IOSPhone") }} />
                        </div>
                    </div>
                </div>
            </div>
        }
        {isDesktopSize &&
            <div className="row bbraun-sand-bg">
                <div className="col-sm">
                    <div className="bbraun-hero bbraun-hero-mutliple-rows bbraun-hero-mutliple-home-rows mb-0">
                        <div>
                            <div className="bbraun-hero-content" dangerouslySetInnerHTML={{ __html: localizationService.getLocalizedText("AndroidPhoneDesc").replace("prepareLink", prepareUrl) }} />
                            <div className="bbraun-hero-content" dangerouslySetInnerHTML={{ __html: localizationService.getLocalizedText("AndroidPhoneDesc2") }} />
                            <div className="bbraun-hero-content" dangerouslySetInnerHTML={{ __html: localizationService.getLocalizedText("AndroidPhoneDesc3") }} />
                        </div>
                        <div>
                            <div className="bbraun-hero-content" dangerouslySetInnerHTML={{ __html: localizationService.getLocalizedText("IOSPhoneDesc").replace("prepareLink", prepareUrl) }} />
                            <div className="bbraun-hero-content" dangerouslySetInnerHTML={{ __html: localizationService.getLocalizedText("IOSPhoneDesc2") }} />
                        </div>
                    </div>
                </div>
            </div>
        }
        {isDesktopSize &&
            <div className="row bbraun-sand-bg">
                <div className="col-sm">
                    <div className="bbraun-hero bbraun-hero-mutliple-rows bbraun-hero-mutliple-home-rows">
                        <div>
                            <div className="bbraun-home-qr-code-container">
                                <img alt="BBraun_MFA_Logo" src={require("../../assets/images/QRCodePlaystore.png")} data-midwidth="800" data-maxwidth="0" />
                            </div>
                            <div className="bbraun-home-app-link">
                                <a className={"bbraun-app-store-link-a"} href={"https://play.google.com/store/apps/details?id=com.bbraun.bkc&gl=DE"}>
                                    <div className="bbraun-app-store-link">
                                        <div className="bbraun-app-store-link-green" />
                                        <div className="bbraun-app-store-link-container" >
                                            <img alt={localizationService.getLocalizedText("ClickHere")} src={require("../../assets/images/GooglePlay.png")} />
                                            <div className="bbraun-app-store-link-title">
                                                {localizationService.getLocalizedText("ClickHere")}
                                            </div>
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div>
                            <div className="bbraun-home-qr-code-container">
                                <img alt="BBraun_MFA_Logo" src={require("../../assets/images/QRCodeAppStore.png")} data-midwidth="800" data-maxwidth="0" />
                            </div>
                            <div className="bbraun-home-app-link">
                                <a className={"bbraun-app-store-link-a"} href={"https://apps.apple.com/de/app/bkc-app/id1597272008"}>
                                    <div className="bbraun-app-store-link">
                                        <div className="bbraun-app-store-link-green" />
                                        <div className="bbraun-app-store-link-container" >
                                            {<img alt={localizationService.getLocalizedText("ClickHere")} src={require("../../assets/images/IOSAppStore.png")} />}
                                            <div className="bbraun-app-store-link-title">
                                                {localizationService.getLocalizedText("ClickHere")}
                                            </div>
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        }
        {!isDesktopSize &&
            <div className="row bbraun-sand-bg">
                <div className="col-sm">
                    <div className="bbraun-hero bbraun-hero-mutliple-rows bbraun-hero-mutliple-home-rows">
                        <div className=' mb-5'>
                            <div className="bbraun-hero-headline" dangerouslySetInnerHTML={{ __html: localizationService.getLocalizedText("AndroidPhone") }} />
                            <div className="bbraun-hero-content" dangerouslySetInnerHTML={{ __html: localizationService.getLocalizedText("AndroidPhoneDesc").replace("prepareLink", prepareUrl) }} />
                            <div className="bbraun-hero-content" dangerouslySetInnerHTML={{ __html: localizationService.getLocalizedText("AndroidPhoneDesc2") }} />
                            <div className="bbraun-hero-content" dangerouslySetInnerHTML={{ __html: localizationService.getLocalizedText("AndroidPhoneDesc3") }} />
                            <div className="bbraun-home-qr-code-container">
                                <img alt="BBraun_MFA_Logo" src={require("../../assets/images/QRCodePlaystore.png")} data-midwidth="800" data-maxwidth="0" />
                            </div>
                            <div className="bbraun-home-app-link">
                                <a className={"bbraun-app-store-link-a"} href={"https://play.google.com/store/apps/details?id=com.bbraun.bkc&gl=DE"}>
                                    <div className="bbraun-app-store-link">
                                        <div className="bbraun-app-store-link-green" />
                                        <div className="bbraun-app-store-link-container" >
                                            <img alt={localizationService.getLocalizedText("ClickHere")} src={require("../../assets/images/GooglePlay.png")} />
                                            <div className="bbraun-app-store-link-title">
                                                {localizationService.getLocalizedText("ClickHere")}
                                            </div>
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div>
                            <div className="bbraun-hero-headline" dangerouslySetInnerHTML={{ __html: localizationService.getLocalizedText("IOSPhone") }} />
                            <div className="bbraun-hero-content" dangerouslySetInnerHTML={{ __html: localizationService.getLocalizedText("IOSPhoneDesc").replace("prepareLink", prepareUrl) }} />
                            <div className="bbraun-hero-content" dangerouslySetInnerHTML={{ __html: localizationService.getLocalizedText("IOSPhoneDesc2") }} />
                            <div className="bbraun-home-qr-code-container">
                                <img alt="BBraun_MFA_Logo" src={require("../../assets/images/QRCodeAppStore.png")} data-midwidth="800" data-maxwidth="0" />
                            </div>
                            <div className="bbraun-home-app-link">
                                <a className={"bbraun-app-store-link-a"} href={"https://apps.apple.com/de/app/bkc-app/id1597272008"}>
                                    <div className="bbraun-app-store-link">
                                        <div className="bbraun-app-store-link-green" />
                                        <div className="bbraun-app-store-link-container" >
                                            {<img alt={localizationService.getLocalizedText("ClickHere")} src={require("../../assets/images/IOSAppStore.png")} />}
                                            <div className="bbraun-app-store-link-title">
                                                {localizationService.getLocalizedText("ClickHere")}
                                            </div>
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        }
        <div className="row bbraun-green-bg bbraun-help-container">
            <div className="col-sm">
                <div className="bbraun-hero">
                    <div className="bbraun-hero-headline">
                        <Icon className="bbraun-help-icon" iconName="Mail" />
                        <span dangerouslySetInnerHTML={{ __html: localizationService.getLocalizedText("NeedHelp") }} />
                    </div>
                </div>
            </div>
        </div>
    </div>
}

export default Home;
